import handleDepositsSubmit from './deposits/submitHandler';
import handleStocksSubmit from './stocks/submitHandler';
import handleRealEstateSubmit from './realEstate/submitHandler';
import handleLoansSubmit from './loans/submitHandler';
import handlePensionSubmit from './pension/submitHandler';
import handleObjectsOfValueSubmit from './objectsOfValue/submitHandler';
import handleMetalsSubmit from './metals/submitHandler';
import handleUnlistedSharesSubmit from './unlistedShares/submitHandler';
import handleCryptoSubmit from './crypto/submitHandler';
import { setMessage } from '../../../redux/actions/message';

const handlers = {
  deposits: handleDepositsSubmit,
  stocks: handleStocksSubmit,
  realEstate: handleRealEstateSubmit,
  loans: handleLoansSubmit,
  pension: handlePensionSubmit,
  objectsOfValue: handleObjectsOfValueSubmit,
  metals: handleMetalsSubmit,
  unlistedShares: handleUnlistedSharesSubmit,
  crypto: handleCryptoSubmit,
};

export default async function handleSubmit({ category, workflowStepStatus, formValues, dispatch, setLoading, setAddModeState, t }) {
  if (!workflowStepStatus.every((item) => !!item)) return;

  setLoading(true);

  const handler = handlers[category];
  if (!handler) {
    console.error(`No submit handler configured for category ${category}`);
    setLoading(false);
    dispatch(setMessage('accountCouldNotBeCreated'));
    return;
  }

  try {
    await handler({ formValues, dispatch, setLoading, category, t });
    setAddModeState({ visible: false, category: null, addAccountState: undefined });
  } catch (err) {
    console.error('handleSubmit: error', err);
    setLoading(false);
    dispatch(setMessage('accountCouldNotBeCreated'));
  }
}
